// https://css-tricks.com/considerations-styling-modal/
const modals = document.querySelectorAll(".modal");
const modalOverlay = document.querySelector(".modal-overlay");
const closeButtons = document.querySelectorAll(".modal__close-button");
const teamMemberBoxes = document.querySelectorAll(".team-member-box");
const body = document.body;

const CLASS_MODAL_OPEN = "modal--open";


function openModal(modalIdx){
  modals[modalIdx].classList.add(CLASS_MODAL_OPEN);
  modalOverlay.classList.add(CLASS_MODAL_OPEN);
  body.classList.add(CLASS_MODAL_OPEN);
}

function closeModals(){
  modals.forEach(function(modal){
    modal.classList.remove(CLASS_MODAL_OPEN);
  });
  modalOverlay.classList.remove(CLASS_MODAL_OPEN);
  body.classList.remove(CLASS_MODAL_OPEN);
}

teamMemberBoxes.forEach(function(teamMemberBox, teamMemberIdx) { 
  teamMemberBox.addEventListener("click", function() {
    openModal(teamMemberIdx);
  });
});

closeButtons.forEach(function(closeButton, teamMemberIdx){
  closeButton.addEventListener("click", function() {
    closeModals();
  });
});

modalOverlay.addEventListener("click", function() {
  closeModals();
});


